module.exports = __webpack_public_path__ + "static/media/Folder-locker.879a9157.png";